/// <reference path="../../../WebUI/typings/tsd.d.ts" />
import * as React from "react";
import * as ReactDOM from "react-dom";
import {resourceStrings} from "../../../Intercom.ReactUI/Views/Strings";
import {DialogBase} from "../Dialogs/DialogBase";
import * as Rest from "../Generated/RestClient";
import { Resources } from "../Resources/Intercom.Resources.DevPortal";
import { Culture } from '../Resources/Culture';

export interface ChannelLogPanelProps extends React.Props<ChannelLogPanel> {
    botId: string;
    channelId: string;
    title: string;
    statusClassName: string;
    channelName: string;
    channelLog: Rest.BotLog[];
    channelLogChangeHandler: () => void;
    dialog: DialogBase;
}

export interface ChannelLogPanelState {
}

export class ChannelLogPanel extends React.Component<ChannelLogPanelProps, ChannelLogPanelState> {
    constructor(props) {
        super(props);
    }

    private onClearAllClick() {
        Rest.BotManagerClient.deleteBotLogs(this.props.botId, this.props.channelId).done(obj => {
            this.props.channelLogChangeHandler();
            this.props.dialog.closeDialog();
        })
    }

    public render(): JSX.Element {

        let entries = this.props.channelLog.map(entry =>
            <tr>
                <td className="channellog-td-time">{new Date(entry.When.toString()).toLocaleString(Culture.CultureCode)}</td>
                <td className="channellog-td-message">{entry.Message}</td>
                <td className="channellog-td-correlationid">{entry.CorrelationId}</td>
            </tr>);

        var title = this.props.channelName;
        var message = Resources.channelIssuesPanelSubtitle;

        return (
            <div className="channellog-panel">
                <div className="dialog-close-button"></div>
                <div className="channellog-title">{title}</div>
                <div className="channellog-message">{message}</div>
                <div className="channellog-clearall-button">
                    <button className="default-button" onClick={() => this.onClearAllClick()}>{Resources.channelIssuesPanelClearall}</button>
                </div>
                <table className="channellog-header-table">
                    <thead>
                        <tr>
                            <th className="channellog-td-time">{Resources.channelIssuesPanelTimeColumnLabel}</th>
                            <th className="channellog-td-message">{Resources.channelIssuesPanelMessageColumnLabel}</th>
                            <th className="channellog-td-correlationid">{Resources.channelIssuesPanelCorrelationIdColumnLabel}</th>
                        </tr>
                    </thead>
                </table>
                <table className="channellog-table">
                    <tbody>
                        {entries}
                    </tbody>
                </table>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./Client/Views/ChannelLogPanel.tsx